// Verified domains of a tenant, fresh from GET .../domains (api.md 2.7), so a domain added in Settings shows on the
// Members and Grants pages at once. A registry before 0.16.0 has no route: then tenant detail `domains` is used.
import type { Domain, TenantDetail } from "../api/types";
import { useServices } from "./context";
import { useLoad, type Loaded } from "./useLoad";

export function useDomains(tenant: TenantDetail): Loaded<Domain[]> {
  const { api } = useServices();
  return useLoad(
    () =>
      api.listDomains(tenant.slug).then(
        (r) => r.items,
        () => tenant.domains ?? [],
      ),
    [tenant.slug],
  );
}
